// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__5xyYV","logo__icon":"Logo_logo__icon__V_xGW"};